import { Building2 } from "lucide-react";
import DynamicReport from "../../../components/reports/DynamicReport";
import {
  hydrateInstitutionReportFilters,
  institutionReportConfig,
} from "../../../config/reportConfigs";

export default function InstitutionReport() {
  return (
    <DynamicReport
      config={institutionReportConfig}
      icon={Building2}
      hydrateFilters={hydrateInstitutionReportFilters}
      defaultPageSize={10}
    />
  );
}
